import React, { useEffect, useState } from 'react';
import { ArrowUpRight, Gift } from 'lucide-react';
import { Link } from 'react-router-dom';
import { resolveApiAssetUrl } from '../lib/api';
import useSwipe from '../hooks/useSwipe';

const SideBanner = ({ banners = [] }) => {
  const [index, setIndex] = useState(0);
  const banner = banners[index];

  // Sayaç index'e de bağlıdır: parmakla kaydıran oyuncu seçtiği banner'ı tam
  // süre görsün, otomatik geçiş kaydırmanın hemen ardına düşmesin.
  useEffect(() => {
    if (banners.length < 2) return undefined;
    const timer = setInterval(
      () => setIndex((current) => (current + 1) % banners.length),
      6000,
    );
    return () => clearInterval(timer);
  }, [banners.length, index]);

  useEffect(() => {
    if (index >= banners.length) setIndex(0);
  }, [banners.length, index]);

  // Yan bannerın tek kumandası köşedeki sayaçtı; mobilde kart parmakla da
  // çevrilir. Kaydırma bittiğinde tıklama düşürülür, yoksa jest kartın
  // bağlantısını açardı (bkz. hooks/useSwipe.js).
  const swipe = useSwipe({
    enabled: banners.length > 1,
    onNext: () => setIndex((current) => (current + 1) % banners.length),
    onPrev: () => setIndex((current) => (current - 1 + banners.length) % banners.length),
  });

  if (!banner) return null;

  return (
    <Link
      to={banner.cta_link || '/promosyonlar'}
      className={`home-side-promo group ${banner.image ? 'has-image' : ''}`}
      {...swipe}
    >
      {banner.image && (
        <img
          src={resolveApiAssetUrl(banner.image)}
          alt={banner.highlight || banner.subtitle || banner.title}
          className="home-side-promo-image"
        />
      )}
      <div className="home-side-promo-shade" />
      {banner.title && (
        <span className="home-side-promo-badge">
          <Gift size={13} /> {banner.title}
        </span>
      )}
      <div className="relative z-10 mt-auto">
        {banner.subtitle && <div className="text-sm text-gray-300">{banner.subtitle}</div>}
        {banner.highlight && (
          <div className="home-side-promo-title text-2xl lg:text-3xl font-black leading-tight mt-1">
            {banner.highlight}
          </div>
        )}
        {banner.description && (
          <p className="home-side-promo-description mt-2 text-xs text-gray-300 line-clamp-2">
            {banner.description}
          </p>
        )}
        <span className="home-side-promo-link mt-4">
          {banner.cta_text || 'Detayları gör'} <ArrowUpRight size={15} />
        </span>
      </div>
      {!banner.image && (
        <>
          <div className="promo-glow promo-glow-one" />
          <div className="promo-glow promo-glow-two" />
        </>
      )}
      {banners.length > 1 && (
        <span className="home-side-promo-counter" aria-label={`${index + 1} / ${banners.length}`}>
          {index + 1}/{banners.length}
        </span>
      )}
    </Link>
  );
};

export default SideBanner;
